import * as React from "react";
import { Box, Dialog, DialogContent, Link, Typography } from "@material-ui/core";

import { IColorRgb } from "Model/IColorRgb";
import { IQuiltRenderData } from "Model/IQuiltRenderData";

export interface IProps {
    readonly quiltRenderData: IQuiltRenderData;

    readonly onClose: () => void;
}

function renderSwatch(color: IColorRgb): React.ReactElement {
    const style: React.CSSProperties = {
        width: "32px",
        height: "16px",
        border: "1px solid black",
        backgroundColor: `rgb(${color.r}, ${color.g}, ${color.b})`
    };

    const r = color.r.toString(16).padStart(2, '0');
    const g = color.g.toString(16).padStart(2, '0');
    const b = color.b.toString(16).padStart(2, '0');

    const str = `#${r}${g}${b}`.toUpperCase();

    return (
        <Box display="flex" flexDirection="row" alignItems="center">
            <div style={style} />
            <Box ml={1}>
                <Typography>{str}</Typography>
            </Box>
        </Box>
    );
}

export function InfoDialog(props: IProps): React.ReactElement {
    const quiltRenderData = props.quiltRenderData;
    const links = quiltRenderData.blocks.map((block, index) => (
        <Link key={index} href={block.sourceUrl} target="_blank">{`Block ${index + 1}`}</Link>
    ));

    const paletteColors = quiltRenderData.blockColors.map((clr, index) => (
        <Box mt={1} key={index}>
            {renderSwatch(clr)}
        </Box>
    ));

    return (
        <Dialog onClose={props.onClose} open>
            <DialogContent>
                <Typography variant="h6">Quilt block sources</Typography>
                <Box display="flex" flexDirection="column">
                    {links}
                </Box>

                <Box pt={1}>
                    <Typography variant="h6">Background color</Typography>
                </Box>
                {renderSwatch(quiltRenderData.backgroundColor)}

                <Box pt={1}>
                    <Typography variant="h6">Block colors</Typography>
                </Box>
                {paletteColors}
            </DialogContent>
        </Dialog>

    )
}